import { z } from 'zod';

export const changeEmailSchema = (t: (key: string) => string) =>
  z.object({
    email: z
      .string()
      .min(1, t('common:errors.required'))
      .email(t('common:errors.email')),
    currentPassword: z.string().min(1, t('common:errors.required')),
  });

export const changeTimezoneSchema = z.object({
  timezone: z.string(),
});

export const changePhoneSchema = (t: (key: string) => string) =>
  z.object({
    phone: z.string().min(1, t('common:errors.required')),
  });

export const changePasswordSchema = (t: (key: string) => string) =>
  z
    .object({
      newPassword: z.string().min(1, t('common:errors.required')),
      currentPassword: z.string().min(1, t('common:errors.required')),
    })
    .refine((data) => data.newPassword !== data.currentPassword, {
      message: t('common:errors.shouldDifferentPassword'),
      path: ['newPassword'],
    });

export const disableTwoFaSchema = (t: (key: string) => string) =>
  z.object({
    currentPassword: z.string().min(1, t('common:errors.required')),
  });

export const legalEntitySchema = (t: (key: string) => string) =>
  z
    .object({
      entityType: z.enum(['ip', 'ooo']),
      name: z.string().min(1, t('common:errors.required')).max(512),
      inn: z
        .string()
        .min(1, t('common:errors.required'))
        .regex(/^(\d{10}|\d{12})$/, t('common:errors.inn.length')),
      kpp: z.string().optional(),
      ogrn: z.string().optional(),
      legalAddress: z.string().optional(),
    })
    .superRefine((value, ctx) => {
      if (value.entityType === 'ooo') {
        if (value.inn.length !== 10) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['inn'],
            message: t('settings:legalEntity.errors.oooInn'),
          });
        }
        if (!/^\d{9}$/.test(value.kpp ?? '')) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['kpp'],
            message: t('settings:legalEntity.errors.kpp'),
          });
        }
      }

      if (value.entityType === 'ip' && value.inn.length !== 12) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['inn'],
          message: t('settings:legalEntity.errors.ipInn'),
        });
      }

      if (value.ogrn && !/^(\d{13}|\d{15})$/.test(value.ogrn)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['ogrn'],
          message: t('settings:legalEntity.errors.ogrn'),
        });
      }
    });
